import React from "react";
import { Link } from "react-router-dom";
import { getScreenPermission } from "../../utils/permissions";

const PermissionLink = ({ to, id, children, className = "" }) => {
  const permissions = getScreenPermission();
  const isAllowed = permissions?.[to] === true;

  if (!isAllowed) {
    return (
      <div
        id={id}
        aria-disabled="true"
        className={`${className} opacity-50 cursor-not-allowed`}
      >
        {children}
      </div>
    );
  }

  return (
    <Link to={to} id={id} className={className}>
      {children}
    </Link>
  );
};

export default PermissionLink;